var _circle, _circle2, _path, _path2, _circle3, _circle4, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStraffe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.8408,
    cy: 14,
    r: 13.3408,
    fill: "#F9F9F9",
    stroke: "#DCDCDC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.6483,
    cy: 14.3608,
    r: 5.43891,
    fill: "#323232"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7578 11.581V9.52679C22.7578 9.47157 22.713 9.42679 22.6578 9.42679H15.0853L16.2724 14.1293C16.2872 14.188 16.3504 14.2202 16.4066 14.1977L22.695 11.6738C22.7329 11.6586 22.7578 11.6218 22.7578 11.581Z",
    fill: "#323232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3995 9.42679H15.0853M15.0853 9.42679H22.6578C22.713 9.42679 22.7578 9.47157 22.7578 9.52679V11.581C22.7578 11.6218 22.7329 11.6586 22.695 11.6738L16.4066 14.1977C16.3504 14.2202 16.2872 14.188 16.2724 14.1293L15.0853 9.42679Z",
    stroke: "#323232"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.20935,
    cy: 14.4258,
    r: 1.03906,
    stroke: "#323232",
    strokeWidth: 0.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.6483,
    cy: 14.4258,
    r: 4.41098,
    fill: "#F9F9F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3215 10.0148H11.7257L14.2978 14.1064L22.3215 11.3679V10.0148Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStraffe);
export default __webpack_public_path__ + "static/media/straffe.8d53ad235fa305ae52bf74b6e193b06d.svg";
export { ForwardRef as ReactComponent };